import React from 'react';
import PropTypes from 'prop-types';

const Passport = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 2.16569H23C23.221 2.16569 23.433 2.25349 23.5893 2.40977C23.7455 2.56605 23.8333 2.77801 23.8333 2.99902V24.999C23.8333 25.22 23.7455 25.432 23.5893 25.5883C23.433 25.7446 23.221 25.8324 23 25.8324H5C4.77899 25.8324 4.56703 25.7446 4.41074 25.5883C4.25446 25.432 4.16667 25.22 4.16667 24.999V2.99902C4.16667 2.77801 4.25446 2.56605 4.41074 2.40977C4.56702 2.25349 4.77899 2.16569 5 2.16569Z"
      stroke={fill || '#6B6C7B'}
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9997 17.1107C15.2374 17.1107 16.4243 16.619 17.2995 15.7438C18.1747 14.8687 18.6663 13.6817 18.6663 12.444M13.9997 17.1107C12.762 17.1107 11.575 16.619 10.6998 15.7438C9.82467 14.8687 9.33301 13.6817 9.33301 12.444M13.9997 17.1107V7.77734M18.6663 12.444C18.6663 11.2063 18.1747 10.0193 17.2995 9.14418C16.4243 8.26901 15.2374 7.77734 13.9997 7.77734M18.6663 12.444H9.33301M13.9997 7.77734C12.762 7.77734 11.575 8.26901 10.6998 9.14418C9.82467 10.0193 9.33301 11.2063 9.33301 12.444"
      stroke={fill || '#6B6C7B'}
      strokeWidth="1.86667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Passport.propTypes = {
  fill: PropTypes.string,
};

export default Passport;
